import { inferAttachmentMimeType } from "@rakazo/core";
import { Paperclip } from "lucide-react";
import { useEffect, useState } from "react";

/** The visible preview owns its URL, so hiding and restoring an app cannot leave a revoked image. */
export function AttachmentPreview({ file }: { file: File }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!inferAttachmentMimeType(file.name, file.type)?.startsWith("image/")) return;
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);
  return url ? (
    <img src={url} alt={file.name} className="h-8 w-8 rounded object-cover" />
  ) : (
    <Paperclip size={14} strokeWidth={1.8} />
  );
}
